<template>
  <div class="restore-point-tabs">
    <mi-tabs v-model="activeTab" class="restore-point-tabs__tabs">
      <mi-tab
        v-for="(tabValue) in tabs"
        :key="tabValue.key"
        :name="tabValue.key"
        :label="tabValue.label"
        class="restore-point-tabs__tab_button"
        data-testid="restore-point-tabs"
      ></mi-tab>
    </mi-tabs>
    <mi-tab-panels v-model="activeTab" keep-alive>
      <mi-tab-panel :name="tabs.PROPERTIES.key" class="restore-point-tabs__tab_panel">
        <config-restore-point-properties-tab
          :configuration="configuration"
          :open-edit-dialog="openEditDialog"
          :configuration-allowed-users-list="configurationAllowedUsersList"
        ></config-restore-point-properties-tab>
      </mi-tab-panel>
      <mi-tab-panel :name="tabs.RESTORE_POINT.key" class="restore-point-tabs__tab_panel q-pl-none">
        <config-restore-point-tab
          :configuration="configuration"
          :toggle-open-side-drawer="toggleOpenSideDrawer"
        >
        </config-restore-point-tab>
      </mi-tab-panel>
    </mi-tab-panels>
  </div>
</template>

<script>
  import { inject, ref, watch } from 'vue'
  import { LocalStorage } from 'quasar'
  import { CONFIG_RESTORE_RECENT_TAB_PROVIDER, CONFIGURATION_RESTORE_POINT_TABS } from '@/constants'
  import MiTabPanels from '@/packages/@mi-library/MiTabPanels/MiTabPanels.vue'
  import MiTab from '@/packages/@mi-library/MiTabs/MiTab.vue'
  import MiTabPanel from '@/packages/@mi-library/MiTabPanels/MiTabPanel.vue'
  import ConfigRestorePointTab from './ConfigurationRestorePointTab.vue'
  import ConfigRestorePointPropertiesTab from './ConfigurationRestorePointPropertiesTab.vue'

  export default {
    name: 'ConfigurationRestorePointTabs',
    components: { MiTabPanel, MiTab, MiTabPanels, ConfigRestorePointTab, ConfigRestorePointPropertiesTab },
    props: {
      configuration: {
        type: Object,
        required: true
      },
      openEditDialog: {
        type: Function,
        required: true
      },
      toggleOpenSideDrawer: {
        type: Function,
        required: true
      }
    },
    emits: ['update:model-value'],
    setup(props) {
      const tabs = ref(CONFIGURATION_RESTORE_POINT_TABS)
      const activeTab = inject(CONFIG_RESTORE_RECENT_TAB_PROVIDER)

      const configurationAllowedUsersList = () => {
        const allowedUsers = props.configuration.authorizedUsers
        return allowedUsers.length > 0 ? allowedUsers?.join(' . ') : 'Everyone'
      }

      watch(activeTab, newVal => {
        LocalStorage.set(process.env.VUE_APP_STORAGE_KEY_CONFIG_RESTORE_RECENT_TAB, newVal)
      })

      return {
        tabs,
        activeTab,
        configurationAllowedUsersList
      }
    }
  }
</script>

<style lang="scss" scoped>
  .restore-point-tabs {
    width: 355px;

    .q-tab-panels {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    &__tabs {
      background-color: $mi-white;
      padding: 0;
    }

    &__tab_button {
      font-family: "Man Europe Condensed", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 21px;
      text-align: left;
      padding: 12px;
    }
  }
</style>
